<template>
  <div class="allergy">

    <div class="allergy-content">
      <div class="header-image">
        <img src="@/assets/images/allergy/banner.jpg" alt=""/>
      </div>

      <div class="allergy-container">
        <div class="card" v-for="(card, index) in cards" :key="index">
          <div class="card-image">
            <img :src="card.img" alt=""/>
          </div>

          <div class="card-content">
            <div class="number">
              {{ index + 1 }}
            </div>
            <hr/>
            <div class="title">
              {{ card.title }}
            </div>

            <div class="text" v-html="card.text"></div>

            <div v-if="card.drop1" class="drop-list drop-list-type1">
              <div v-bind:class="[{ active: card.drop1.show }]" @click="card.drop1.show = !card.drop1.show"
                   class="list-title">
                {{ card.drop1.name }}
                <svg viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.75684 1.24316L6.26953 5.77864" stroke="white" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.26957 5.77864L10.7788 1.24316" stroke="white" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="list-table" v-if="card.drop1.show">
                <div class="list" v-for="(secondKey, secondValue) in card.drop1.list">
                  <div class="icon" v-html="secondKey.icon"></div>
                  <div class="text" v-html="secondKey.text"></div>
                </div>
              </div>
            </div>

            <div v-if="card.drop3" class="drop-list drop-list-type3">
              <div v-bind:class="[{ active: card.drop3.show }]" @click="card.drop3.show =  !card.drop3.show"
                   class="list-title">
                {{ card.drop3.name }}
                <svg viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.75684 1.24316L6.26953 5.77864" stroke="white" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.26957 5.77864L10.7788 1.24316" stroke="white" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="list-table" v-if="card.drop3.show">
                <div class="list" v-for="(secondKey, secondValue) in card.drop3.list">
                  <div class="icon" v-html="secondKey.icon"></div>
                  <div class="text" v-html="secondKey.text"></div>
                </div>
              </div>
            </div>

            <div v-if="card.drop2" class="drop-list drop-list-type2">
              <div v-bind:class="[{ active: card.drop2.show }]" @click="card.drop2.show = !card.drop2.show"
                   class="list-title">
                {{ card.drop2.name }}
                <svg viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.75684 1.24316L6.26953 5.77864" stroke="white" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.26957 5.77864L10.7788 1.24316" stroke="white" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>

              <div class="drop-list drop-list-type2" v-if="card.drop2.show">

                <table cellspacing="0">
                  <thead>
                  <tr>
                    <td>{{ card.drop2.left.name }}</td>
                    <td>{{ card.drop2.right.name }}</td>
                  </tr>
                  </thead>

                  <tbody>
                  <tr>
                    <td>
                      <div class="icon-text">
                        <div class="icon" v-html="card.drop2.left.list[0].icon"></div>
                        <div class="text" v-html="card.drop2.left.list[0].text"></div>
                      </div>
                    </td>
                    <td>
                      <div class="icon-text">
                        <div class="icon" v-html="card.drop2.right.list[0].icon"></div>
                        <div class="text" v-html="card.drop2.right.list[0].text"></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="icon-text">
                        <div class="icon" v-html="card.drop2.left.list[1].icon"></div>
                        <div class="text" v-html="card.drop2.left.list[1].text"></div>
                      </div>
                    </td>
                    <td>
                      <div class="icon-text">
                        <div class="icon meat" v-html="card.drop2.right.list[1].icon"></div>
                        <div class="text" v-html="card.drop2.right.list[1].text"></div>
                      </div>
                    </td>
                  </tr>
                  </tbody>

                </table>


              </div>
            </div>

            <div v-if="card.drop4" class="drop-list drop-list-type4">
              <div v-bind:class="[{ active: card.drop4.show }]" @click="card.drop4.show =  !card.drop4.show"
                   class="list-title">
                {{ card.drop4.name }}
                <svg viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.75684 1.24316L6.26953 5.77864" stroke="white" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.26957 5.77864L10.7788 1.24316" stroke="white" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="list-table-type3" v-if="card.drop4.show">
                <div class="list" v-for="(secondKey, secondValue) in card.drop4.list">
                  <div class="icon" v-html="secondKey.icon"></div>
                  <div class="text" v-html="secondKey.text"></div>
                </div>
              </div>
            </div>

            <div v-if="card.drop5" class="drop-list drop-list-type5">
              <div v-bind:class="[{ active: card.drop5.show }]" @click="card.drop5.show = !card.drop5.show"
                   class="list-title">
                {{ card.drop5.name }}
                <svg viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.75684 1.24316L6.26953 5.77864" stroke="white" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.26957 5.77864L10.7788 1.24316" stroke="white" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>

              <div class="table-wrapper " v-if="card.drop5.show">

                <table cellspacing="0">
                  <thead>

                  <tr>
                    <td></td>
                    <td>{{ card.drop5.table.row1.text1 }}</td>
                    <td>{{ card.drop5.table.row1.text2 }}</td>
                  </tr>

                  </thead>

                  <tbody>
                  <tr>

                    <td>{{ card.drop5.table.row2.text1 }}</td>
                    <td>{{ card.drop5.table.row2.text2 }}</td>
                    <td>{{ card.drop5.table.row2.text3 }}</td>
                  </tr>
                  <tr>

                    <td>{{ card.drop5.table.row3.text1 }}</td>
                    <td>{{ card.drop5.table.row3.text2 }}</td>
                    <td>{{ card.drop5.table.row3.text3 }}</td>
                  </tr>
                  <tr>

                    <td>{{ card.drop5.table.row4.text1 }}</td>
                    <td>{{ card.drop5.table.row4.text2 }}</td>
                    <td>{{ card.drop5.table.row4.text3 }}</td>
                  </tr>
                  </tbody>

                </table>


              </div>
            </div>

            <div v-if="card.drop6" class="drop-list drop-list-type5">
              <div v-bind:class="[{ active: card.drop6.show }]" @click="card.drop6.show = !card.drop6.show"
                   class="list-title">
                {{ card.drop6.name }}
                <svg viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.75684 1.24316L6.26953 5.77864" stroke="white" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.26957 5.77864L10.7788 1.24316" stroke="white" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>

              <div class="table-wrapper " v-if="card.drop6.show">

                <table cellspacing="0">
                  <thead>

                  <tr>
                    <td></td>
                    <td>{{ card.drop6.table.row1.text1 }}</td>
                    <td>{{ card.drop6.table.row1.text2 }}</td>
                  </tr>

                  </thead>

                  <tbody>
                  <tr>

                    <td>{{ card.drop6.table.row2.text1 }}</td>
                    <td>{{ card.drop6.table.row2.text2 }}</td>
                    <td>{{ card.drop6.table.row2.text3 }}</td>
                  </tr>
                  <tr>

                    <td>{{ card.drop6.table.row3.text1 }}</td>
                    <td>{{ card.drop6.table.row3.text2 }}</td>
                    <td>{{ card.drop6.table.row3.text3 }}</td>
                  </tr>
                  </tbody>

                </table>


              </div>
            </div>


          </div>

          <div class="card-link" v-if="card.link">

            <router-link class="url" :to="card.link.ref">{{
                card.link.name
              }}
            </router-link>
          </div>

          <div class="card-link" v-if="card.link2">

            <router-link class="url" :to="card.link2.ref">{{
                card.link2.name
              }}
            </router-link>
          </div>

          <div class="card-note" v-if="card.note">
            <hr/>
            <p class="card-note__text">
              {{ card.note }}
            </p>
          </div>
        </div>

        <div class="allergy-container-info">
          <strong>
            Безумовна перевага у годуванні дитини перших років життя надається грудному вигодовуванню.
          </strong>
          <br>
          <br>
          Згідно рекомендацій МОЗ України воно є основним харчуванням для малюка на першому році життя навіть після
          введення прикорму.
          <br>
          <br>
          ВООЗ рекомендує зберігати грудне вигодовування до 2 років.
          <br>
          <br>
          Nutricia підтримує зазначені рекомендації та попереджає, що штучне вигодовування може негативно вплинути на
          грудне.
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import Image1 from "@/assets/images/allergy/img1.jpg";
import Image2 from "@/assets/images/allergy/img2.jpg";
import Image3 from "@/assets/images/allergy/img3.jpg";
import Image4 from "@/assets/images/allergy/img4.jpg";
import Image5 from "@/assets/images/allergy/img5.jpg";
import Image6 from "@/assets/images/allergy/img6.jpg";
import Image7 from "@/assets/images/allergy/img7.jpg";
import Image8 from "@/assets/images/allergy/img8.jpg";
import Image9 from "@/assets/images/allergy/img9.jpg";
import Image10 from "@/assets/images/allergy/img10.jpg";
import Image11 from "@/assets/images/allergy/img11.jpg";

export default {
  name: "allergy",
  data: () => ({

    cards: [
      {
        img: Image1,
        title: "Поширеність проблеми сягає 6%",
        text:
            "Основним харчовим алергеном, з яким стикаються діти раннього віку, є <b>білок коров’ячого молока</b> (БКМ), що може міститися у грудному молоці, дитячій суміші та прикормі. Своєчасна дієтотерапія може знизити ризик алергічного маршу, який здатен від атопічного дерматиту призвести до бронхіальної астми та алергічного риніту у більш старшому віці",
        link: "",
      },
      {
        img: Image2,
        title: "Портрет пацієнта",
        text: "<b>Шкірні прояви</b> легкої форми алергії починаються з сухості шкіри, почервоніння та свербіжу. <b>Гастроінтестинальні прояви:</b> набряки у ротовій порожнині, зригування, кольки, діарея, кров у випорожненнях, дратівливість та відмова від їжі з втратою ваги (навіть без супутніх шкірних проявів). <b>Респіраторні прояви:</b> кашель, чхання, диспное та стридор",
        link: "",
      },
      {
        img: Image3,
        title: "Дієтотерапія за різних типів вигодовування",
        text: "<b>При виключно грудному вигодовуванні</b> – виключення з раціону матері продуктів, що містять чи можуть містити БКМ та інші алергени, у т.ч. здатні викликати перехресну реакцію. <b>При виключно штучному вигодовуванні</b> – призначення спеціальної суміші з глибоко гідролізованим білком або вільними амінокислотами",
        drop1: {
          name: "Продукти, що містять білок коров'ячого молока",
          list: [
            {
              icon: "<svg width=\"18\" height=\"23\" viewBox=\"0 0 18 23\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<path d=\"M8.10226 21.5615V8.57975L4.84222 3.43188L1.53418 8.57975V21.5615H17.3138V8.57975L14.0612 3.43188H4.84222\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M8.10303 8.57983H17.3146\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M4.84326 3.4318V0.760498H14.0622V3.4318\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "</svg>",
              text: "Молоко, вершки, пінка, сметана"
            },
            {
              icon: "<svg width=\"19\" height=\"23\" viewBox=\"0 0 19 23\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<path d=\"M17.4661 2.68054V20.5883C17.4661 20.8719 17.292 21.1235 17.0189 21.1997C16.1059 21.4542 13.7321 21.962 9.32655 21.9622C4.92082 21.9624 2.54703 21.4543 1.63412 21.1997C1.36106 21.1236 1.18701 20.8719 1.18701 20.5885V2.68054\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\"/>\n" +
                  "<path d=\"M14.854 12.3822C14.854 15.4969 12.3875 17.9984 9.37354 17.9984C6.35961 17.9984 3.89306 15.4969 3.89306 12.3822C3.89306 9.26753 6.35961 6.7661 9.37354 6.7661C12.3875 6.7661 14.854 9.26753 14.854 12.3822Z\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\"/>\n" +
                  "<path d=\"M8.66433 15.3451C8.23784 15.3451 7.8877 15.0087 7.8877 14.5969V14.1206V11.5882C7.8877 11.1765 8.23784 10.8401 8.66433 10.8401H10.3624C10.7889 10.8401 11.139 11.1765 11.139 11.5882V14.1206V14.5969C11.139 15.0087 10.7889 15.3451 10.3624 15.3451H8.66433V15.3451Z\" stroke=\"#9AB9D8\" stroke-width=\"0.69335\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M8.41992 15.2851V14.1495C8.41992 13.875 8.65423 13.6516 8.93855 13.6516H10.089C10.3733 13.6516 10.6076 13.875 10.6076 14.1495V15.2851\" stroke=\"#9AB9D8\" stroke-width=\"0.69335\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M5.86024 11.7942C5.63647 11.7942 6.20512 12.6311 6.97385 12.4939C7.74259 12.3566 7.88475 12.1817 7.88475 12.1817\" stroke=\"#9AB9D8\" stroke-width=\"0.69335\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M7.88486 11.9128C7.88486 11.9128 7.47943 11.4849 6.8318 11.4849C6.18417 11.4849 6.08149 11.797 5.86035 11.797\" stroke=\"#9AB9D8\" stroke-width=\"0.69335\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M11.1362 11.9128C11.1362 11.9128 11.5417 11.4849 12.1893 11.4849C12.8369 11.4849 12.9396 11.797 13.1607 11.797C13.3819 11.797 12.8159 12.634 12.0471 12.4967C11.2784 12.3595 11.1362 12.1846 11.1362 12.1846\" stroke=\"#9AB9D8\" stroke-width=\"0.69335\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M7.88365 11.5878C7.88365 11.5878 7.18863 10.043 8.52602 8.95312C8.52602 8.95312 8.16271 10.8423 8.88932 10.8423\" stroke=\"#9AB9D8\" stroke-width=\"0.69335\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M11.1365 11.5878C11.1365 11.5878 11.8315 10.043 10.4942 8.95312C10.4942 8.95312 10.8575 10.8423 10.1309 10.8423\" stroke=\"#9AB9D8\" stroke-width=\"0.69335\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<ellipse cx=\"9.32704\" cy=\"2.51846\" rx=\"8.13954\" ry=\"1.35659\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\"/>\n" +
                  "</svg>",
              text: "Сухе молоко, згущене молоко"
            },
            {
              icon: "<svg width=\"26\" height=\"16\" viewBox=\"0 0 26 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<path d=\"M19.8358 1.29749H1.37402V15.3121H19.8358V1.29749Z\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M25.3179 1.29675H19.832V15.3114H25.3179V1.29675Z\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M19.8281 14.8286L23.6061 7.96027L19.8281 1.29675\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M25.3181 1.29675L22.5752 6.14627\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M25.3181 15.308L22.5752 10.8352\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M8.93338 12.4479C8.34091 12.4479 7.85449 11.9908 7.85449 11.4312V10.7839V7.3424C7.85449 6.78284 8.34091 6.32568 8.93338 6.32568H11.2923C11.8848 6.32568 12.3712 6.78284 12.3712 7.3424V10.7839V11.4312C12.3712 11.9908 11.8848 12.4479 11.2923 12.4479H8.93338V12.4479Z\" stroke=\"#9AB9D8\" stroke-width=\"1.04002\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M8.59424 12.3679V10.8245C8.59424 10.4515 8.91973 10.1479 9.31472 10.1479H10.9129C11.3079 10.1479 11.6334 10.4515 11.6334 10.8245V12.3679\" stroke=\"#9AB9D8\" stroke-width=\"1.04002\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M5.03809 7.62354C4.72722 7.62354 5.51719 8.76094 6.58511 8.57442C7.65303 8.3879 7.85052 8.15018 7.85052 8.15018\" stroke=\"#9AB9D8\" stroke-width=\"1.04002\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M7.85052 7.78145C7.85052 7.78145 7.2873 7.19995 6.38761 7.19995C5.48793 7.19995 5.3453 7.62419 5.03809 7.62419\" stroke=\"#9AB9D8\" stroke-width=\"1.04002\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M12.3706 7.78145C12.3706 7.78145 12.9338 7.19995 13.8335 7.19995C14.7332 7.19995 14.8758 7.62419 15.183 7.62419C15.4902 7.62419 14.7039 8.7616 13.636 8.57508C12.5681 8.38856 12.3706 8.15084 12.3706 8.15084\" stroke=\"#9AB9D8\" stroke-width=\"1.04002\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M7.85089 7.34266C7.85089 7.34266 6.88537 5.2434 8.74326 3.76221C8.74326 3.76221 8.23856 6.3296 9.24796 6.3296\" stroke=\"#9AB9D8\" stroke-width=\"1.04002\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M12.3707 7.34266C12.3707 7.34266 13.3362 5.2434 11.4783 3.76221C11.4783 3.76221 11.983 6.3296 10.9736 6.3296\" stroke=\"#9AB9D8\" stroke-width=\"1.04002\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "</svg>",
              text: "Масло, маргарин"
            },
            {
              icon: "<svg width=\"25\" height=\"17\" viewBox=\"0 0 25 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<path d=\"M12.5078 6.44202H1.41406C1.41406 6.44202 1.41406 7.15486 1.41406 8.71316C1.41406 13.0598 7.57765 14.4291 7.57765 15.4669V16.1731H12.5078\" stroke=\"#9AB9D8\" stroke-width=\"1.31736\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M12.5063 6.44202H23.6001C23.6001 6.44202 23.6001 7.15486 23.6001 8.71316C23.6001 13.0598 17.4366 14.4291 17.4366 15.4669V16.1731H12.5063\" stroke=\"#9AB9D8\" stroke-width=\"1.31736\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M1.41406 8.71301H23.5983\" stroke=\"#9AB9D8\" stroke-width=\"1.31736\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M3.17676 5.97512V5.82593C3.17676 4.98709 3.85644 4.30741 4.69527 4.30741H5.94523V4.08195C5.94523 3.24312 6.62492 2.56344 7.46375 2.56344H8.6706C8.6706 1.72461 9.35029 1.04492 10.1891 1.04492H14.5955\" stroke=\"#9AB9D8\" stroke-width=\"1.31736\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M22.0338 5.97512V5.82593C22.0338 4.98709 21.3542 4.30741 20.5153 4.30741H19.2654V4.08195C19.2654 3.24312 18.5857 2.56344 17.7469 2.56344H16.54C16.54 1.72461 15.8603 1.04492 15.0215 1.04492H13.5991\" stroke=\"#9AB9D8\" stroke-width=\"1.31736\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "</svg>\n",
              text: "Сир, йогурт"
            },
            {
              icon: "<svg width=\"11\" height=\"25\" viewBox=\"0 0 11 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<path d=\"M10.4016 7.6223L7.35948 3.66117H7.78421H7.92288V3.5225V1.05981V0.921145H7.78421H2.81406H2.67539V1.05981V3.5225V3.66117H2.81406H3.28114L0.197229 7.62157L0.167971 7.65914V7.70677V11.0449C0.167971 11.5907 0.407553 12.0814 0.774648 12.4279C0.410926 12.7451 0.184774 13.212 0.184774 13.7314C0.184774 14.2254 0.395513 14.6707 0.727966 14.9852C0.395873 15.3002 0.188974 15.7456 0.188974 16.2389C0.188974 16.7575 0.410664 17.2247 0.774012 17.5424C0.406928 17.8889 0.167971 18.3797 0.167971 18.9255V21.7911C0.167971 22.8429 1.04589 23.7208 2.09766 23.7208H3.88354C4.18692 23.933 4.55851 24.079 4.9633 24.079H5.6797C6.08449 24.079 6.45609 23.933 6.75948 23.7208H8.54535C9.6017 23.7208 10.4303 22.8383 10.4303 21.7911V18.9255C10.4303 18.3829 10.2111 17.8914 9.8458 17.5429C10.2106 17.2266 10.4471 16.7601 10.4471 16.2388C10.4471 15.7457 10.2415 15.3002 9.90946 14.9851C10.2418 14.6704 10.4513 14.2251 10.4513 13.7313C10.4513 13.2094 10.2104 12.7431 9.84526 12.4273C10.2106 12.0789 10.4303 11.5874 10.4303 11.0448V7.70677V7.65966L10.4016 7.6223ZM7.82899 17.0404H7.69032V17.1791V17.8507V17.9894H7.82899H8.54539C9.07371 17.9894 9.48134 18.397 9.48134 18.9253V21.791C9.48134 22.3268 9.06649 22.7717 8.54539 22.7717H7.48277C7.54914 22.5663 7.58705 22.3696 7.58705 22.1492V22.0105H7.44838H6.77676H6.63809V22.1492C6.63809 22.6812 6.20446 23.1299 5.67975 23.1299H4.9633C4.43863 23.1299 4.00496 22.6812 4.00496 22.1492V22.0105H3.86629H3.19467H3.056V22.1492C3.056 22.3696 3.09391 22.5663 3.16027 22.7717H2.09766C1.56938 22.7717 1.11693 22.3193 1.11693 21.791V18.9253C1.11693 18.4043 1.56188 17.9894 2.09766 17.9894H5.67975H5.81842V17.8507V17.1791V17.0404H5.67975H1.9186C1.48904 17.0404 1.13937 16.6908 1.13937 16.2612C1.13937 15.8316 1.48904 15.482 1.9186 15.482H5.67975H5.81842V15.3433V14.6717V14.533H5.67975H1.9186C1.48904 14.533 1.13937 14.1833 1.13937 13.7538C1.13937 13.3242 1.48904 12.9745 1.9186 12.9745H5.67975H5.81842V12.8359V12.1643V12.0256H5.67975H2.09766C1.56938 12.0256 1.11693 11.5732 1.11693 11.0449V8.31788H9.48134V11.0449C9.48134 11.5806 9.06649 12.0256 8.54539 12.0256H7.82899H7.69032V12.1643V12.8359V12.9745H7.82899H8.7245C9.15406 12.9745 9.50373 13.3242 9.50373 13.7538C9.50373 14.1833 9.15406 14.533 8.7245 14.533H7.82899H7.69032V14.6717V15.3433V15.482H7.82899H8.7245C9.15406 15.482 9.50373 15.8316 9.50373 16.2612C9.50373 16.6908 9.15406 17.0404 8.7245 17.0404H7.82899ZM3.6244 2.71217V1.87011H6.97392V2.71217H3.6244ZM1.62843 7.36887L4.48053 3.66117H6.16243L9.01453 7.36887H1.62843Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.27734\"/>\n" +
                  "</svg>\n",
              text: "Сироватка, лактоза, казеїн, лактоальбумін"
            }
          ],
          show: false
        },
        drop2: {
          name: "Продукти, що можуть викликати перехресну харчову алергію",
          left: {
            name: "Первинна алергія",
            list: [
              {
                text: "Коров’яче молоко",
                icon: "<svg width=\"15\" height=\"20\" viewBox=\"0 0 15 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                    "<path d=\"M6.33284 19.1469V7.89633L3.50753 3.43494L0.640625 7.89633V19.1469H14.316V7.89633L11.4971 3.43494H3.50753\" stroke=\"#9AB9D8\" stroke-width=\"1.21333\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                    "<path d=\"M6.3335 7.89648H14.3167\" stroke=\"#9AB9D8\" stroke-width=\"1.21333\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                    "<path d=\"M3.5083 3.43508V1.12H11.4979V3.43508\" stroke=\"#9AB9D8\" stroke-width=\"1.21333\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                    "</svg>\n"
              },
              {
                text: "Коров’яче молоко",
                icon: "<svg width=\"15\" height=\"20\" viewBox=\"0 0 15 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                    "<path d=\"M6.33284 19.1469V7.89633L3.50753 3.43494L0.640625 7.89633V19.1469H14.316V7.89633L11.4971 3.43494H3.50753\" stroke=\"#9AB9D8\" stroke-width=\"1.21333\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                    "<path d=\"M6.3335 7.89648H14.3167\" stroke=\"#9AB9D8\" stroke-width=\"1.21333\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                    "<path d=\"M3.5083 3.43508V1.12H11.4979V3.43508\" stroke=\"#9AB9D8\" stroke-width=\"1.21333\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                    "</svg>\n"
              }
            ]
          },
          right: {
            name: "Пов'язана алергія",
            list: [
              {
                text: "Козяче молоко<br><span>ймовірність – 90%</span>",
                icon: "<svg width=\"11\" height=\"24\" viewBox=\"0 0 31 67\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                    "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.2606 7.41858C3.26513 8.69253 3.85325 9.87636 4.82728 10.6505L1.82443 17.8555L1.82419 17.8561L1.82411 17.8563C0.616636 20.7461 -0.00344223 23.8473 1.43722e-05 26.9793V60.672L1.49862e-05 60.6725C0.00412792 64.1653 2.83472 66.9959 6.3275 67H23.7193C27.2121 66.9959 30.0427 64.1653 30.0468 60.6725V26.9798C30.0501 23.8469 29.4296 20.7449 28.2213 17.8543L25.2195 10.6505C26.1936 9.87639 26.7817 8.69255 26.7863 7.41858L26.7863 7.41699V4.15483C26.7863 1.86016 24.9261 0 22.6314 0H7.41542C5.12075 0 3.26059 1.86016 3.26059 4.15483V7.41699L3.2606 7.41858ZM7.41542 3.06797C6.8152 3.06797 6.32856 3.55461 6.32856 4.15483V7.4154C6.32856 8.01562 6.8152 8.50226 7.41542 8.50226H22.6314C23.2316 8.50226 23.7183 8.01562 23.7183 7.4154V4.15483C23.7183 3.55461 23.2316 3.06797 22.6314 3.06797H7.41542ZM8.14035 10.676L4.65588 19.0317C4.34898 19.7809 4.08623 20.5474 3.869 21.3272C5.53284 21.4485 7.16068 21.8717 8.67291 22.576C9.41782 22.9353 10.2124 23.1804 11.0303 23.3031C12.284 23.2864 13.5244 23.0422 14.6908 22.5825C16.1042 22.0319 17.6084 21.7513 19.1252 21.7554C20.1933 21.8769 21.2336 22.1759 22.2032 22.6401C23.6038 23.3179 25.1331 23.6885 26.6887 23.727C26.4413 22.1172 26.0034 20.5425 25.3844 19.0361L21.9065 10.676H8.14035ZM23.7183 63.932C25.5191 63.932 26.9789 62.4723 26.9789 60.6715V26.9778C26.9789 26.7283 26.9627 26.4824 26.9466 26.2365C26.9391 26.1214 26.9315 26.0063 26.9256 25.8909C26.8872 25.8927 26.8485 25.8949 26.8098 25.8971C26.7115 25.9027 26.6128 25.9083 26.517 25.9083C24.7431 25.8356 23.0018 25.4085 21.3957 24.6519C20.6505 24.2924 19.8555 24.0473 19.0372 23.9248C17.7825 23.9399 16.5411 24.1844 15.3745 24.6465C13.9618 25.1971 12.4584 25.4774 10.9423 25.4725C9.87457 25.3509 8.83458 25.0519 7.86537 24.5878C6.46523 23.9097 4.93616 23.5391 3.381 23.5009C3.17871 24.6493 3.07396 25.8128 3.06798 26.9789V60.6715C3.06798 62.4723 4.52777 63.932 6.32856 63.932H23.7183Z\" fill=\"#9AB9D8\"/>\n" +
                    "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.2036 22.6405C23.3659 23.203 24.617 23.554 25.8981 23.679C26.1607 23.7047 26.4245 23.7208 26.6891 23.7274C26.649 23.4669 26.604 23.2074 26.5541 22.9489C26.2952 21.6098 25.9036 20.2992 25.3848 19.0365L21.9069 10.6764H8.14073L4.65626 19.0321C4.4494 19.5371 4.26259 20.0499 4.09627 20.5694C4.01583 20.8206 3.94018 21.0734 3.86937 21.3276C4.13086 21.3466 4.39145 21.3732 4.65085 21.4071C6.04201 21.5889 7.39872 21.9828 8.67329 22.5764C9.41819 22.9357 10.2128 23.1808 11.0307 23.3035C12.2844 23.2868 13.5248 23.0426 14.6912 22.5829C16.1045 22.0323 17.6088 21.7517 19.1256 21.7558C20.1937 21.8773 21.234 22.1763 22.2036 22.6405ZM11.0836 22.5288C12.2221 22.5061 13.3478 22.2808 14.4075 21.8631L14.4089 21.8625L14.4104 21.862C15.9139 21.2762 17.5141 20.9778 19.1277 20.9821L19.1705 20.9822L19.213 20.9871C20.3667 21.1183 21.4904 21.4412 22.5377 21.9427L22.5392 21.9434L22.5406 21.9441C23.5537 22.4344 24.6393 22.7517 25.7525 22.885C25.5039 21.6699 25.1415 20.4802 24.6697 19.3317C24.6695 19.3313 24.6693 19.3309 24.6692 19.3305L21.3908 11.4501H8.65636L5.3722 19.3254C5.3719 19.3262 5.3716 19.3269 5.3713 19.3277C5.19216 19.7651 5.02866 20.2086 4.88108 20.6575C6.30506 20.8567 7.69335 21.2665 8.99993 21.875L9.0047 21.8772L9.00945 21.8795C9.66561 22.1961 10.3643 22.4147 11.0836 22.5288ZM10.9426 25.4729C9.87495 25.3513 8.83496 25.0522 7.86575 24.5882C6.46561 23.9101 4.93653 23.5395 3.38137 23.5013C3.17908 24.6497 3.07434 25.8132 3.06836 26.9792V60.6718C3.06836 62.4726 4.52815 63.9324 6.32893 63.9324H23.7187C25.5195 63.9324 26.9792 62.4726 26.9792 60.6718V26.9782C26.9792 26.7287 26.9631 26.4828 26.947 26.2369C26.9394 26.1219 26.9319 26.007 26.926 25.8917C26.926 25.8915 26.926 25.8914 26.926 25.8913C26.9104 25.892 26.8947 25.8929 26.879 25.8937C26.8561 25.8949 26.8332 25.8962 26.8102 25.8975C26.7483 25.901 26.6862 25.9046 26.6248 25.9067C26.5887 25.9079 26.5528 25.9087 26.5173 25.9087C24.7434 25.836 23.0022 25.4089 21.396 24.6523C20.6509 24.2928 19.8558 24.0477 19.0376 23.9252C17.7829 23.9403 16.5415 24.1848 15.3749 24.6468C13.9622 25.1975 12.4588 25.4778 10.9426 25.4729ZM18.9843 24.6998C17.8453 24.721 16.7191 24.9466 15.6598 25.3662L15.6578 25.367L15.6558 25.3677C14.1529 25.9535 12.5533 26.2518 10.9402 26.2466L10.8975 26.2464L10.8551 26.2416C9.70184 26.1103 8.5785 25.7873 7.53161 25.286L7.53007 25.2852L7.52853 25.2845C6.4305 24.7527 5.24713 24.4245 4.0359 24.3138C3.91153 25.1973 3.84672 26.0885 3.84205 26.9813V60.6718C3.84205 62.0453 4.95545 63.1587 6.32893 63.1587H23.7187C25.0922 63.1587 26.2055 62.0453 26.2055 60.6718V26.9782C26.2055 26.8715 26.2025 26.7694 26.1977 26.667C24.4203 26.5576 22.6789 26.1119 21.0663 25.3522L21.0631 25.3507L21.0599 25.3491C20.4034 25.0324 19.7041 24.8137 18.9843 24.6998ZM7.41579 3.84206C7.24288 3.84206 7.10263 3.9823 7.10263 4.15522V7.41579C7.10263 7.58871 7.24288 7.72895 7.41579 7.72895H22.6318C22.8047 7.72895 22.945 7.58871 22.945 7.41579V4.15522C22.945 3.9823 22.8047 3.84206 22.6318 3.84206H7.41579ZM7.41579 3.06836C6.81557 3.06836 6.32893 3.555 6.32893 4.15522V7.41579C6.32893 8.01601 6.81557 8.50265 7.41579 8.50265H22.6318C23.232 8.50265 23.7187 8.01601 23.7187 7.41579V4.15522C23.7187 3.555 23.232 3.06836 22.6318 3.06836H7.41579Z\" fill=\"#9AB9D8\"/>\n" +
                    "</svg>"
              },
              {
                text: "Яловичина<br><span>ймовірність – 10%</span>",
                icon: "<svg viewBox=\"0 0 22 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                    "<path d=\"M20.3698 5.31853V9.51796C20.3908 11.7077 16.8692 15.4452 11.02 15.5442C5.17081 15.6431 6.46064 13.6274 3.52703 11.2607C1.62829 9.72793 0.869388 8.78606 0.956377 8.03916V4.08569\" stroke=\"#9AB9D8\" stroke-width=\"1.28267\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                    "<path d=\"M1.80416 2.72163C3.89488 1.24283 6.77149 1.54278 10.704 1.73776C14.6364 1.93273 20.3477 3.12657 20.3687 5.31628C20.3897 7.50598 16.8681 11.2435 11.0189 11.3425C5.16971 11.4415 6.45953 9.42572 3.52593 7.05904C0.592321 4.69236 0.37635 3.73249 1.80416 2.72163Z\" stroke=\"#9AB9D8\" stroke-width=\"1.28267\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                    "<path d=\"M7.05791 5.97544C7.9906 5.97544 8.74669 5.5524 8.74669 5.03057C8.74669 4.50873 7.9906 4.08569 7.05791 4.08569C6.12523 4.08569 5.36914 4.50873 5.36914 5.03057C5.36914 5.5524 6.12523 5.97544 7.05791 5.97544Z\" stroke=\"#9AB9D8\" stroke-width=\"1.28267\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                    "</svg>\n"
              }
            ]
          },
          show: false
        },
        drop3: {
          name: "Продукти, що можуть містити білок коров’ячого молока",
          list: [
            {
              icon: "<svg width=\"22\" height=\"22\" viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<g clip-path=\"url(#clip0_4852_6076)\">\n" +
                  "<path d=\"M10.8946 2.58849C8.05559 2.58849 5.5162 3.05448 3.6809 3.82411C2.7635 4.20881 2.01497 4.67233 1.49364 5.19779C0.971436 5.72414 0.670761 6.31993 0.670761 6.96216V15.4124C0.670761 16.0546 0.971436 16.6504 1.49364 17.1767C2.01497 17.7022 2.7635 18.1657 3.6809 18.5504C5.5162 19.32 8.05559 19.786 10.8946 19.786C13.7336 19.786 16.273 19.32 18.1083 18.5504C19.0257 18.1657 19.7742 17.7022 20.2955 17.1767C20.8177 16.6504 21.1184 16.0546 21.1184 15.4124V6.96216C21.1184 6.31993 20.8177 5.72414 20.2955 5.19779C19.7742 4.67233 19.0257 4.20881 18.1083 3.82411C16.273 3.05448 13.7336 2.58849 10.8946 2.58849ZM10.8946 3.53565C13.6989 3.53565 16.0352 3.99563 17.665 4.66465C18.4803 4.99935 19.1125 5.38377 19.5382 5.78352C19.9652 6.18438 20.1712 6.58718 20.1712 6.96216C20.1712 7.33714 19.9652 7.73995 19.5382 8.1408C19.1125 8.54055 18.4803 8.92497 17.665 9.25967C16.0352 9.9287 13.6989 10.3887 10.8946 10.3887C8.09028 10.3887 5.75395 9.9287 4.12417 9.25967C3.3088 8.92497 2.67667 8.54055 2.25091 8.1408C1.82399 7.73995 1.61793 7.33714 1.61793 6.96216C1.61793 6.58718 1.82399 6.18438 2.25091 5.78352C2.67667 5.38377 3.3088 4.99935 4.12417 4.66465C5.75395 3.99563 8.09028 3.53565 10.8946 3.53565ZM1.61793 15.4124V8.84403C2.30027 9.47806 3.31957 10.0172 4.57085 10.43V17.8814C3.64914 17.55 2.92228 17.1564 2.4198 16.7398C1.8795 16.2918 1.61793 15.8344 1.61793 15.4124ZM10.8946 18.8389C8.81205 18.8389 6.98772 18.5848 5.51802 18.1796V10.7067C7.07084 11.1068 8.9081 11.3358 10.8946 11.3358C12.8811 11.3358 14.7183 11.1068 16.2711 10.7067V18.1796C14.8014 18.5848 12.9771 18.8389 10.8946 18.8389ZM20.1712 15.4124C20.1712 15.8344 19.9097 16.2918 19.3693 16.7398C18.8669 17.1564 18.14 17.55 17.2183 17.8814V10.43C18.4696 10.0172 19.4889 9.47806 20.1712 8.84403V15.4124Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.29715\"/>\n" +
                  "<path d=\"M13.3709 14.0895V15.5411C13.3763 16.298 12.4782 17.59 10.9866 17.6242C9.49492 17.6584 9.82385 16.9616 9.07572 16.1436C8.59151 15.6137 8.39797 15.2881 8.42016 15.03V13.6634\" stroke=\"#9AB9D8\" stroke-width=\"0.9905\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M8.63697 13.022C9.1701 12.5723 9.90364 12.6636 10.9064 12.7228C11.9092 12.7821 13.3656 13.1451 13.3709 13.8109C13.3763 14.4767 12.4783 15.6132 10.9867 15.6433C9.49518 15.6734 9.82409 15.0605 9.07602 14.3409C8.32795 13.6212 8.27287 13.3294 8.63697 13.022Z\" stroke=\"#9AB9D8\" stroke-width=\"0.9905\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M16.2464 8.59632L16.2464 8.59632L13.4381 5.74247L13.4256 5.59441C13.4255 5.59442 13.4254 5.59444 13.4253 5.59445C13.075 5.62399 12.7743 5.8326 12.5653 6.13254C12.356 6.43279 12.2323 6.83159 12.2323 7.26614C12.2323 8.1089 12.7753 8.85927 13.5138 8.85927C13.5479 8.85927 13.5824 8.85757 13.6157 8.85405L16.2464 8.59632ZM13.489 6.63156L13.4894 6.63152C13.4969 6.63087 13.5046 6.63059 13.5138 6.63059C13.5227 6.63059 13.5325 6.63105 13.5429 6.63187L16.1724 6.88989C16.346 6.90702 16.497 7.01174 16.5765 7.17288C16.5878 7.19606 16.5945 7.21327 16.5983 7.22471C16.5945 7.23604 16.5877 7.25313 16.5763 7.27628L16.5763 7.27639C16.4969 7.43802 16.3458 7.54278 16.1724 7.55993C16.1724 7.55993 16.1724 7.55993 16.1724 7.55994L13.541 7.81802C13.5409 7.81803 13.5408 7.81804 13.5407 7.81805C13.4452 7.82688 13.3423 7.7828 13.2572 7.68096C13.1722 7.5792 13.1121 7.42592 13.1121 7.24385C13.1121 7.07368 13.1618 6.91887 13.2371 6.80735C13.3132 6.69454 13.4054 6.63858 13.489 6.63156Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.29715\"/>\n" +
                  "</g>\n" +
                  "<defs>\n" +
                  "<clipPath id=\"clip0_4852_6076\">\n" +
                  "<rect width=\"20.8005\" height=\"20.8005\" fill=\"white\" transform=\"translate(0.493652 0.786926)\"/>\n" +
                  "</clipPath>\n" +
                  "</defs>\n" +
                  "</svg>\n",
              text: "Промислово перероблене м’ясо"
            },
            {
              icon: "<svg width=\"17\" height=\"25\" viewBox=\"0 0 17 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<g clip-path=\"url(#clip0_4852_6082)\">\n" +
                  "<path d=\"M0.458008 2.62446C0.458008 2.81457 0.553064 2.90963 0.553064 3.09974C0.64812 3.1948 0.838232 3.38491 1.02834 3.47996C1.21846 3.57502 1.40857 3.67008 1.69374 3.76513C2.26407 3.95524 2.92946 4.0503 3.68991 4.14536C5.21081 4.43053 6.92182 4.52558 8.15755 4.52558C9.39327 4.52558 11.1043 4.43052 12.6252 4.24041C13.3856 4.14536 14.051 3.95525 14.6214 3.86019C14.9065 3.76513 15.0966 3.67008 15.3818 3.57502C15.5719 3.47996 15.762 3.28985 15.8571 3.1948C15.9521 3.09974 15.9521 2.90963 15.9521 2.71952C15.9521 2.43435 15.8571 2.24424 15.5719 2.05412C15.3818 1.86401 15.0966 1.76896 14.7164 1.57884C14.051 1.29368 13.1955 1.19862 12.245 1.10356C10.4389 0.913452 8.53777 0.913452 8.15755 0.913452C7.77732 0.913452 5.8762 0.913452 4.07014 1.10356C3.11958 1.10356 2.26407 1.29368 1.59868 1.48379C1.21846 1.6739 0.933288 1.76896 0.743176 1.95907C0.553064 2.14918 0.458008 2.33929 0.458008 2.62446ZM8.15755 3.38491C6.06631 3.38491 4.45036 3.1948 3.40474 3.00468C2.83441 3.00468 2.35913 2.90963 2.07396 2.81457C1.88385 2.71952 1.69374 2.71952 1.59868 2.62446C1.69374 2.5294 1.88385 2.5294 1.9789 2.43435C2.26407 2.33929 2.73935 2.24424 3.30969 2.14918C4.45036 1.95907 6.06631 1.76896 8.15755 1.76896C10.2488 1.76896 11.8647 1.95907 13.0054 2.14918C13.5757 2.24424 14.051 2.33929 14.3362 2.43435C14.4312 2.5294 14.6214 2.5294 14.7164 2.62446C14.6214 2.62446 14.5263 2.71952 14.3362 2.81457C14.051 2.90963 13.5757 3.00468 13.0054 3.09974C11.8647 3.28985 10.2488 3.38491 8.15755 3.38491Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.27734\"/>\n" +
                  "<path d=\"M15.6668 2.52924C15.6668 2.52924 13.2904 3.95508 8.15739 4.05013C2.92931 4.05013 0.647961 2.52924 0.647961 2.52924C0.647961 2.52924 1.78863 3.95508 0.362793 2.90946C0.362793 3.00452 0.362793 3.00452 0.362793 3.00452V5.09575C0.362793 5.38092 0.457849 5.57103 0.743017 5.76114C0.933129 5.8562 1.2183 6.04631 1.59852 6.14137C2.26391 6.33148 3.11942 6.52159 4.06998 6.61665C5.87604 6.80676 7.77716 6.80676 8.15739 6.80676C8.53761 6.80676 10.4387 6.80676 12.2448 6.61665C13.1954 6.52159 14.0509 6.33148 14.7163 6.14137C15.0965 6.04631 15.3816 5.8562 15.5718 5.66609C15.7619 5.47597 15.952 5.28586 15.952 5.00069V2.90946C15.8569 2.71935 15.8569 2.62429 15.6668 2.52924ZM14.9064 4.90564C14.9064 4.90564 14.8113 4.90564 14.8113 5.00069C14.7163 5.00069 14.6212 5.09575 14.4311 5.1908C14.1459 5.28586 13.6706 5.38092 13.1003 5.47597C11.9596 5.66608 10.3437 5.8562 8.15739 5.8562C5.9711 5.8562 4.35515 5.66608 3.21447 5.47597C2.64414 5.38092 2.26391 5.28586 1.97875 5.1908C1.78863 5.09575 1.69358 5.09575 1.59852 5.00069C1.50347 5.00069 1.50347 4.90564 1.50347 4.90564V3.76496C2.45403 4.14519 3.40459 4.3353 4.4502 4.3353C5.68593 4.43036 6.92166 4.52541 8.25244 4.52541V4.43036V4.52541C9.48817 4.52541 10.7239 4.43036 12.0547 4.3353C13.1003 4.24024 14.0509 4.05013 15.0014 3.76496V4.90564H14.9064Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.27734\"/>\n" +
                  "<path d=\"M15.3818 4.33514C15.0966 4.33514 14.9065 4.52526 14.8115 4.81042C14.8115 4.81042 14.7164 4.81042 14.7164 4.90548C14.6214 4.90548 14.5263 5.00054 14.3362 5.09559C14.051 5.19065 13.5757 5.2857 13.0054 5.38076C11.8647 5.57087 10.2488 5.76098 8.06249 5.76098C5.97126 5.66593 4.3553 5.57087 3.21463 5.38076C2.6443 5.2857 2.26407 5.09559 1.88385 5.00054C1.78879 5.00054 1.69374 4.90548 1.59868 4.90548C1.50362 4.90548 1.50362 4.81042 1.50362 4.81042C1.50362 4.52526 1.21846 4.33514 0.933288 4.33514C0.64812 4.33514 0.458008 4.62031 0.458008 4.90548V22.2057C0.458008 22.4908 0.553064 22.681 0.838232 22.8711C1.02834 23.0612 1.31351 23.1562 1.69374 23.3463C2.26407 23.5365 3.11958 23.7266 4.07014 23.8216C5.8762 24.0117 7.77732 24.0117 8.15755 24.0117C8.53777 24.0117 10.4389 24.0117 12.245 23.8216C13.1955 23.7266 14.051 23.5365 14.7164 23.3463C15.0966 23.2513 15.3818 23.0612 15.5719 22.8711C15.762 22.681 15.9521 22.4908 15.9521 22.2057V4.90548C15.9521 4.62031 15.667 4.33514 15.3818 4.33514ZM1.50362 5.9511C2.45418 6.33132 3.88002 6.52143 5.21081 6.61649C6.54159 6.71154 7.87238 6.71154 8.15755 6.71154C8.44271 6.71154 9.7735 6.71154 11.1043 6.61649C12.4351 6.52143 13.8609 6.33132 14.8115 5.9511V10.894V10.9891V11.5594V22.1106C14.8115 22.1106 14.7164 22.1106 14.7164 22.2057C14.6214 22.2057 14.5263 22.3007 14.3362 22.3958C14.051 22.4908 13.5757 22.5859 13.0054 22.681C11.8647 22.8711 10.2488 23.0612 8.06249 23.0612C5.8762 23.0612 4.26025 22.8711 3.11958 22.681C2.54924 22.5859 2.07396 22.4908 1.78879 22.3958C1.59868 22.3007 1.50362 22.3007 1.40857 22.2057C1.31351 22.2057 1.31351 22.1106 1.31351 22.1106V11.5594V10.894V5.9511H1.50362Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.27734\"/>\n" +
                  "<path d=\"M3.68966 11.1789C4.16494 10.9887 4.64022 11.0838 5.1155 11.464C5.59078 11.7492 5.87595 12.3195 5.971 12.7948C6.06606 13.3651 6.16112 13.9355 6.35123 14.5058C6.92156 16.4069 7.20673 18.7833 7.30179 20.1141C7.30179 20.3993 7.20673 20.6845 6.92156 20.9696C6.35123 21.4449 5.49572 21.2548 5.21056 20.4943L2.64404 12.9849C2.64404 12.2245 3.02427 11.369 3.68966 11.1789Z\" stroke=\"#9AB9D8\" stroke-width=\"1.3867\"/>\n" +
                  "<path d=\"M12.3393 21.7304C11.864 21.7304 11.3887 21.3501 11.1035 20.9699C10.8184 20.4946 10.7233 19.9243 10.8184 19.354C10.9134 18.7836 11.1035 18.2133 11.1035 17.643C11.3887 15.6468 11.959 13.9358 12.3393 13.1753C12.4343 12.9852 12.5294 12.8902 12.7195 12.7951C13.4799 12.3198 14.5255 12.8902 14.4305 13.8407L13.7651 20.5897C13.7651 21.2551 13.0997 21.7304 12.3393 21.7304Z\" stroke=\"#9AB9D8\" stroke-width=\"1.3867\"/>\n" +
                  "<path d=\"M7.96674 17.9281C7.58652 17.9281 7.30135 17.6429 7.20629 17.2627C6.92112 16.3121 6.73101 14.8863 6.92112 13.3654C7.11124 11.9395 6.92112 10.1335 6.73101 8.61259C6.5409 7.56697 7.49146 6.61641 8.44202 6.71147C9.29753 6.80652 9.86786 7.56697 9.7728 8.32742L9.01236 16.9775C9.01236 17.5479 8.53708 17.9281 7.96674 17.9281Z\" stroke=\"#9AB9D8\" stroke-width=\"1.3867\"/>\n" +
                  "</g>\n" +
                  "<defs>\n" +
                  "<clipPath id=\"clip0_4852_6082\">\n" +
                  "<rect width=\"15.7793\" height=\"23.5739\" fill=\"white\" transform=\"translate(0.26709 0.628052)\"/>\n" +
                  "</clipPath>\n" +
                  "</defs>\n" +
                  "</svg>\n",
              text: "Консервовані овочі"
            },
            {
              icon: "<svg width=\"24\" height=\"25\" viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<g clip-path=\"url(#clip0_4852_6091)\">\n" +
                  "<path d=\"M4.97963 19.1631L5.13679 19.3203C5.45111 19.6346 5.844 19.7917 6.2369 19.8703C6.31548 20.2632 6.47264 20.6561 6.78696 20.9704C7.10128 21.2848 7.49418 21.4419 7.88707 21.5205C7.96565 21.992 8.27997 22.542 8.75145 22.9349C9.22293 23.4064 9.85157 23.6421 10.4016 23.6421C10.4802 23.6421 10.5588 23.6421 10.6374 23.6421H10.8731L10.9517 23.5636L12.1304 21.049L18.5739 14.6055C19.4383 13.7411 20.4598 12.9553 21.5599 12.4053L22.9744 11.698L23.0529 11.6195L22.9744 11.5409L12.9162 1.48269L12.8376 1.40411L12.759 1.56127L12.0518 2.97571C11.5017 4.07582 10.7945 5.09736 9.85157 5.96173L8.90861 8.3977L9.61583 7.84764C10.5588 6.90469 12.4447 4.70446 13.0733 3.44718L13.1519 3.29002L21.2456 11.3837L21.0885 11.4623C19.8312 12.0909 18.7311 12.8767 17.7881 13.8197L11.5017 20.1061L10.9517 21.049L10.1659 22.6206C10.1659 22.6206 9.69441 22.4635 9.38009 22.1491C8.83003 21.7562 9.45867 21.1276 8.83003 20.5775C8.43713 20.2632 7.88707 20.5775 7.65134 20.3418C7.33702 20.0275 7.4156 19.556 7.4156 19.556C7.4156 19.3203 7.33702 19.1631 7.17986 19.006C6.94412 18.9274 6.70838 18.8488 6.55122 18.8488C6.31548 18.8488 6.07974 18.7702 5.92258 18.6131C5.68684 18.4559 5.60827 18.2202 5.60827 17.9058C5.60827 17.8273 5.52969 17.7487 5.52969 17.5915V17.6701C5.52969 17.5915 5.45111 17.4344 5.37253 17.3558C5.21537 17.1986 5.05821 17.12 4.90105 17.12V17.1986V17.12H4.82247C4.58673 17.12 4.42957 17.0415 4.27241 16.8843C4.11525 16.8057 4.03667 16.57 4.03667 16.3342C4.03667 16.1771 3.95809 15.9413 3.80093 15.7842C3.64377 15.627 3.48662 15.5484 3.25088 15.5484C3.09372 15.5484 2.93656 15.4699 2.7794 15.3913C2.62224 15.3127 2.46508 15.1556 2.30792 14.9984C2.07218 14.7627 1.9936 14.5269 1.91502 14.2912L3.64377 13.5054L3.48662 13.6625L3.40804 13.7411L3.48662 13.8197L4.11525 14.4483L4.19383 14.5269L4.27241 14.4483L4.90105 13.8197L4.97963 13.7411L4.90105 13.6625L4.27241 13.0339L8.90861 8.3977L9.85157 5.96173L3.32946 12.2481L0.814908 13.3482H0.736328V13.4268V13.6625C0.736328 13.7411 0.736328 13.8197 0.736328 13.8983C0.736328 14.4483 0.972067 14.9984 1.44354 15.5484C1.83644 16.0199 2.3865 16.3342 2.85798 16.4128C2.93656 16.8057 3.09372 17.1986 3.40804 17.5129C3.64377 17.8273 4.03667 17.9844 4.42957 18.063C4.50815 18.4559 4.66531 18.8488 4.97963 19.1631Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.161782\"/>\n" +
                  "<path d=\"M15.8251 14.0563C14.4106 15.6279 12.0532 15.6279 10.5602 14.2135C9.0672 12.799 8.98862 10.3631 10.4816 8.87006\" stroke=\"#9AB9D8\" stroke-width=\"0.97069\"/>\n" +
                  "<path d=\"M10.4029 8.79064C10.7958 8.39774 12.6032 9.10495 14.0962 10.5194C15.5892 11.9338 16.2178 13.6626 15.9035 13.9769C15.5106 14.3698 14.0176 13.5054 12.5246 12.091C11.0316 10.6765 10.01 9.18353 10.4029 8.79064Z\" stroke=\"#9AB9D8\" stroke-width=\"0.97069\"/>\n" +
                  "<path d=\"M10.0098 9.49841C10.6384 9.57699 11.9743 10.2056 13.2315 11.3843C14.3316 12.4844 15.1174 13.6631 15.2746 14.3703\" fill=\"#9AB9D8\"/>\n" +
                  "<path d=\"M16.1394 9.9696C16.1394 9.9696 16.0609 10.834 15.2751 10.834C14.4893 10.9126 14.4893 11.6984 14.4893 11.6984\" stroke=\"#9AB9D8\" stroke-width=\"0.808908\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M15.2752 9.18408C15.2752 9.18408 15.1966 10.0485 14.4108 10.0485C13.625 10.127 13.625 10.9128 13.625 10.9128\" stroke=\"#9AB9D8\" stroke-width=\"0.808908\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M14.4109 8.31952C14.4109 8.31952 14.3323 9.18389 13.5465 9.18389C12.7607 9.26247 12.7607 10.1269 12.7607 10.1269\" stroke=\"#9AB9D8\" stroke-width=\"0.808908\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M6.11265 14.7253L5.22363 13.8363L4.33461 14.7253L5.22363 15.6143L6.11265 14.7253Z\" fill=\"#9AB9D8\"/>\n" +
                  "<path d=\"M7.01988 15.7155L6.13086 14.8265L5.24184 15.7155L6.13086 16.6045L7.01988 15.7155Z\" fill=\"#9AB9D8\"/>\n" +
                  "<path d=\"M7.98326 16.6503L7.09424 15.7613L6.20522 16.6503L7.09424 17.5393L7.98326 16.6503Z\" fill=\"#9AB9D8\"/>\n" +
                  "<path d=\"M8.94664 17.5856L8.05762 16.6965L7.1686 17.5856L8.05762 18.4746L8.94664 17.5856Z\" fill=\"#9AB9D8\"/>\n" +
                  "<path d=\"M9.90953 18.6311L9.02051 17.7421L8.13149 18.6311L9.02051 19.5201L9.90953 18.6311Z\" fill=\"#9AB9D8\"/>\n" +
                  "<path d=\"M10.8724 19.5659L9.9834 18.6769L9.09438 19.5659L9.9834 20.4549L10.8724 19.5659Z\" fill=\"#9AB9D8\"/>\n" +
                  "<path d=\"M11.8353 20.5005L10.9463 19.6115L10.0573 20.5005L10.9463 21.3895L11.8353 20.5005Z\" fill=\"#9AB9D8\"/>\n" +
                  "</g>\n" +
                  "<defs>\n" +
                  "<clipPath id=\"clip0_4852_6091\">\n" +
                  "<rect width=\"23.5739\" height=\"23.5739\" fill=\"white\" transform=\"translate(0.107422 0.775879)\"/>\n" +
                  "</clipPath>\n" +
                  "</defs>\n" +
                  "</svg>\n",
              text: "Консервовані супи"
            },
            {
              icon: "<svg width=\"26\" height=\"17\" viewBox=\"0 0 26 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<path d=\"M3.14534 5.65815C2.9207 5.49213 2.60398 5.53961 2.43794 5.76427C2.27192 5.98891 2.31939 6.30563 2.54405 6.47167L2.54436 6.4719C2.78178 6.64602 3.03207 6.85251 3.31156 7.10008L3.31153 7.10011L3.31367 7.1019C3.98876 7.66838 4.46598 8.43501 4.67633 9.29077C4.93789 10.3553 5.52957 11.3097 6.36665 12.0175C7.12076 12.6968 8.0541 13.1419 9.05287 13.3017L3.91039 6.42011M3.14534 5.65815L3.08353 5.74179L3.14531 5.65813C3.14532 5.65814 3.14533 5.65814 3.14534 5.65815ZM3.14534 5.65815C3.40732 5.8516 3.67913 6.06247 3.97948 6.34233M3.97948 6.34233C3.97884 6.34179 3.9782 6.34125 3.97756 6.34071L3.91039 6.42011M3.97948 6.34233C3.98009 6.3429 3.9807 6.34347 3.98131 6.34404L3.91039 6.42011M3.97948 6.34233C4.81493 7.04972 5.40382 8.00445 5.66107 9.06849M3.91039 6.42011C4.7301 7.11348 5.30786 8.04975 5.56007 9.09331M5.66107 9.06849C5.66104 9.06838 5.66101 9.06826 5.66098 9.06814L5.56007 9.09331M5.66107 9.06849C5.87453 9.92393 6.3529 10.69 7.0278 11.2574L7.03094 11.26L7.03088 11.2601C7.68256 11.8532 8.503 12.2283 9.37789 12.3331M5.66107 9.06849C5.6611 9.06862 5.66113 9.06875 5.66116 9.06888L5.56007 9.09331M5.56007 9.09331C5.77879 9.97018 6.26911 10.7555 6.96088 11.337L9.37789 12.3331M9.37789 12.3331C9.65499 12.3477 9.86891 12.5832 9.85637 12.861C9.85637 12.861 9.85637 12.861 9.85637 12.861L9.75247 12.8563C9.74766 12.9633 9.7014 13.0587 9.62989 13.1276L9.37789 12.3331Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.208005\"/>\n" +
                  "<path d=\"M18.9835 6.21994C18.5555 6.47493 18.1029 6.6867 17.6325 6.85193L17.6322 6.85203C15.6854 7.52932 13.5559 7.45539 11.6608 6.64472L11.655 6.64224L11.6551 6.64207C11.4055 6.51699 11.3047 6.21328 11.4298 5.96376C11.5457 5.73266 11.8174 5.6263 12.0594 5.71721L12.064 5.71896L12.064 5.71907C13.722 6.43406 15.5869 6.50606 17.2951 5.92097C17.9994 5.67527 18.6544 5.30628 19.2296 4.83127L19.2958 4.91146L19.2293 4.83155C19.4437 4.65294 19.7624 4.68194 19.941 4.89638L18.9835 6.21994ZM18.9835 6.21994C18.5394 9.68669 15.8769 12.3374 12.6891 12.3374H9.45801C9.17888 12.3374 8.95264 12.5636 8.95264 12.8427C8.95264 13.1219 9.17894 13.3481 9.45801 13.3481H12.6891C16.762 13.3481 20.0581 9.67899 20.0581 5.21645L20.0581 5.21561C20.0572 5.09889 20.0158 4.98607 19.941 4.89641L18.9835 6.21994Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.208005\"/>\n" +
                  "<path d=\"M8.63456 12.705L8.63139 12.7175V12.7241C8.63109 12.7257 8.63061 12.728 8.62989 12.7311C8.62768 12.7407 8.62401 12.7548 8.61861 12.7729C8.60784 12.809 8.59076 12.859 8.56624 12.9182C8.51713 13.0368 8.43913 13.1898 8.32407 13.3407C8.09524 13.6408 7.72194 13.9309 7.12988 13.9309C6.85076 13.9309 6.62451 14.1572 6.62451 14.4363C6.62451 14.7154 6.85076 14.9417 7.12988 14.9417L7.13217 14.9417C8.31421 14.9156 9.33189 14.1001 9.61501 12.9522C9.68315 12.6817 9.51913 12.407 9.24855 12.3386C8.97784 12.2702 8.70295 12.4343 8.63456 12.705Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.208005\"/>\n" +
                  "<path d=\"M12.3479 12.927C12.622 14.0379 13.6121 14.8234 14.7562 14.8376L12.651 12.4272C12.4293 12.4816 12.2936 12.7053 12.3479 12.927ZM12.3479 12.927L12.3479 12.927L12.3479 12.927ZM13.2547 12.7235V12.7177L13.2517 12.7055C13.1837 12.4281 12.9037 12.2583 12.6262 12.3262L12.6262 12.3262C12.3487 12.3942 12.1789 12.6742 12.2469 12.9517L12.2469 12.9519C12.5323 14.1088 13.5634 14.9268 14.7549 14.9416V14.9416H14.7562C15.0353 14.9416 15.2615 14.7153 15.2615 14.4362C15.2615 14.1571 15.0353 13.9308 14.7562 13.9308C14.1725 13.9308 13.799 13.6409 13.5678 13.3402C13.4516 13.1891 13.3721 13.0359 13.3217 12.9172C13.2966 12.8579 13.279 12.8079 13.2678 12.7718C13.2622 12.7537 13.2584 12.7396 13.2561 12.73C13.2555 12.7272 13.255 12.725 13.2547 12.7235Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.208005\"/>\n" +
                  "<path d=\"M4.20477 15.3909L4.20477 15.3909L3.83566 14.6728C3.83563 14.6728 3.8356 14.6727 3.83556 14.6727C3.70719 14.425 3.80386 14.1201 4.05153 13.9916L4.20477 15.3909ZM4.20477 15.3909L4.20502 15.3914M4.20477 15.3909L4.20502 15.3914M4.20502 15.3914C4.58139 16.1143 5.33342 16.5631 6.14842 16.5511H15.6918C16.5067 16.5631 17.2588 16.1144 17.6352 15.3914L17.6352 15.3914M4.20502 15.3914L17.6352 15.3914M17.6352 15.3914L17.636 15.3897M17.6352 15.3914L17.636 15.3897M17.636 15.3897L17.9925 14.6728C17.9926 14.6725 17.9928 14.6723 17.9929 14.672C18.03 14.6001 18.0493 14.5202 18.0491 14.4393V14.4393M17.636 15.3897L18.0491 14.4393M18.0491 14.4393C18.0485 14.1602 17.8218 13.9345 17.5428 13.935M18.0491 14.4393L17.5428 13.935M17.5428 13.935H4.29884C4.21297 13.9326 4.12786 13.952 4.05154 13.9916L17.5428 13.935ZM6.14641 15.5404C5.7222 15.5455 5.3304 15.3164 5.12658 14.9457H16.7136C16.5097 15.3164 16.118 15.5455 15.6938 15.5404V15.5404H15.6925H6.14765V15.5404L6.14641 15.5404Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.208005\"/>\n" +
                  "<path d=\"M22.301 1.17879L22.3011 1.17851L22.2935 1.17682C20.4565 0.772613 18.6072 1.80456 17.9865 3.58012L17.9865 3.58013C17.8025 4.10653 17.8025 4.67974 17.9865 5.2061L17.9868 5.20689C18.2109 5.83211 18.8131 6.24112 19.4769 6.21897L19.4769 6.21919L19.4838 6.21851C19.7626 6.19064 19.966 5.94196 19.9382 5.66314C19.9106 5.38705 19.6665 5.18493 19.3911 5.20799C19.1779 5.19546 18.9944 5.05231 18.9306 4.84801C18.8349 4.53609 18.8455 4.20121 18.9606 3.89593L18.9606 3.89594L18.9613 3.89424C19.4147 2.6262 20.7315 1.88477 22.0506 2.15429C23.2889 2.48377 24.2862 3.8036 24.2864 5.20349C24.2763 6.62628 23.4455 7.91517 22.154 8.51189C21.5992 8.72905 21.0207 8.88022 20.4305 8.96217L20.4305 8.96204L20.4254 8.963C20.3639 8.97467 20.3017 8.98624 20.239 8.99791C19.981 9.0459 19.7141 9.09554 19.4529 9.16079C18.6857 9.34248 18.0879 9.64988 17.681 10.0689C17.2721 10.4899 17.0615 11.0179 17.0615 11.626C17.0615 11.9051 17.2878 12.1313 17.5669 12.1313C17.846 12.1313 18.0723 11.9051 18.0723 11.626C18.0723 11.1813 18.2822 10.8603 18.5897 10.6231C18.9004 10.3834 19.3077 10.2323 19.6868 10.1375C19.963 10.0713 20.2497 10.0186 20.5339 9.96633C20.5553 9.9624 20.5766 9.95847 20.598 9.95454C21.2684 9.85953 21.9252 9.68502 22.5544 9.43473L22.5544 9.43486L22.5595 9.43255C24.2125 8.67099 25.2785 7.02483 25.2971 5.20493L25.2971 5.20379C25.2957 3.34811 24.0783 1.71264 22.301 1.17879Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.208005\"/>\n" +
                  "<path d=\"M12.0846 5.71864L12.0855 5.71902C12.3401 5.83327 12.454 6.13233 12.3397 6.38699C12.3397 6.387 12.3397 6.38702 12.3397 6.38704L12.2448 6.34445C12.209 6.42441 12.1479 6.49041 12.071 6.53241L12.0846 5.71864ZM12.0846 5.71864C11.5532 5.48614 11.0563 5.18186 10.6076 4.81432L10.6072 4.81393C9.20451 3.67857 7.44883 3.06978 5.64443 3.09292L12.0846 5.71864ZM10.6812 6.11604C10.1766 6.30656 9.83594 6.7914 9.8357 7.33909V7.33914V8.36666H9.83565L9.83576 8.37008C9.84089 8.52608 9.73838 8.66508 9.58824 8.70651C9.50255 8.72056 9.41495 8.69644 9.34853 8.64041L9.34803 8.63999C9.28095 8.58412 9.2418 8.50159 9.24097 8.41432L9.24098 7.34318L9.24097 7.34314C9.24072 6.77885 8.8721 6.2809 8.33254 6.11583L8.33187 6.11563C8.04339 6.0295 7.77021 5.8988 7.52214 5.72822L7.52214 5.72821L7.52103 5.72747C6.76707 5.22314 5.87723 4.96078 4.97025 4.97538C4.24212 4.96895 3.52316 5.13515 2.87216 5.46004C2.63739 5.29631 2.39052 5.15071 2.13374 5.02452C3.19989 4.411 4.41164 4.09253 5.64401 4.10373L5.64643 4.1037C7.21481 4.08133 8.7416 4.60836 9.96224 5.59347C10.1908 5.7826 10.4309 5.95711 10.6812 6.11604Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.208005\"/>\n" +
                  "</svg>\n",
              text: "Соуси, підливи"
            },
            {
              icon: "<svg width=\"21\" height=\"17\" viewBox=\"0 0 21 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<path d=\"M9.99156 16.179H4.54694C3.68908 16.179 2.99402 15.4839 2.99402 14.6261V6.37617C2.99402 6.37617 1.1875 5.82514 1.1875 4.56965C1.1875 3.31416 2.7185 0.925293 9.91642 0.925293\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M9.28076 16.1785H15.0385C15.8963 16.1785 16.5914 15.4834 16.5914 14.6256V6.37568C16.5914 6.37568 18.3979 5.82465 18.3979 4.56916C18.3979 3.31367 16.8669 0.924805 9.66899 0.924805\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M11.1592 16.1785H16.9169C17.7748 16.1785 18.4698 15.4834 18.4698 14.6256V6.37568C18.4698 6.37568 20.2763 5.82465 20.2763 4.56916C20.2763 3.31367 18.7453 0.924805 11.5474 0.924805\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M7.58105 7.92806V7.3551\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M9.77246 3.85805V3.2851\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M11.6504 6.98915V6.4162\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M9.77246 10.7469V10.174\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M7.58105 13.8773V13.3044\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M12.2773 13.5643V12.9914\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M13.8428 9.80666V9.2337\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M14.4849 4.21868V3.80853\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M5.38916 4.79799V4.22504\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M5.38916 11.6862V11.1132\" stroke=\"#9AB9D8\" stroke-width=\"1.24803\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "</svg>\n",
              text: "Хліб"
            },
            {
              icon: "<svg width=\"19\" height=\"22\" viewBox=\"0 0 19 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<g clip-path=\"url(#clip0_4852_6132)\">\n" +
                  "<path d=\"M8.61563 6.03723H8.1709C8.1709 5.94828 8.34879 5.94828 8.61563 6.03723Z\" stroke=\"#9AB9D8\" stroke-width=\"1.17765\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M13.9476 9.68208L5.23633 8.97095C5.23633 8.97095 11.6365 9.59318 13.9476 9.68208Z\" stroke=\"#9AB9D8\" stroke-width=\"1.17765\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M16.526 9.85983L13.9481 9.68205C11.637 9.59316 5.23681 8.97092 5.23681 8.97092L13.9481 9.68205C14.3926 9.68205 14.6593 9.68205 14.7481 9.68205C15.2815 9.50427 15.6371 8.88203 15.6371 7.81534C15.6371 6.74864 14.3926 6.39308 14.3926 6.39308L8.61467 6.03752C8.348 6.03752 8.17022 6.03752 8.17022 6.03752H8.61467C9.77025 6.12641 12.7037 6.2153 12.8814 5.94863C13.1481 5.68195 13.1481 4.70415 12.7037 4.17081C12.2592 3.63746 10.4814 3.54857 9.94803 3.10411C9.41469 2.57077 9.94803 1.41518 9.94803 1.41518C9.94803 1.41518 7.90354 0.881839 6.83685 2.57077C5.85905 4.17081 6.83685 5.77084 6.83685 5.77084C6.83685 5.77084 5.3257 5.14861 4.3479 6.30419C3.28121 7.45977 3.99234 8.88203 3.99234 8.88203C2.74786 8.79314 1.59228 9.41538 1.50339 11.0154C1.4145 12.6155 3.10343 13.1488 3.10343 13.1488H3.45899H6.57018H9.94803H13.1481H16.4371H16.7926C16.7926 13.1488 17.7704 12.7932 17.9482 11.4599C18.0371 10.1265 16.526 9.85983 16.526 9.85983Z\" stroke=\"#9AB9D8\" stroke-width=\"1.17765\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M9.94817 13.1487L9.85928 20.26L9.94817 13.1487ZM9.94817 13.1487H6.57031L7.54811 20.4377H11.8149L13.2371 13.1487H9.94817Z\" stroke=\"#9AB9D8\" stroke-width=\"1.17765\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M3.45898 13.1487L5.59237 20.4377H7.54797L6.57017 13.1487H3.45898Z\" stroke=\"#9AB9D8\" stroke-width=\"1.17765\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M11.8149 20.4377H14.1261L16.4373 13.1487H13.2372L11.8149 20.4377Z\" stroke=\"#9AB9D8\" stroke-width=\"1.17765\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "</g>\n" +
                  "<defs>\n" +
                  "<clipPath id=\"clip0_4852_6132\">\n" +
                  "<rect width=\"17.6893\" height=\"20.8005\" fill=\"white\" transform=\"translate(0.880859 0.526123)\"/>\n" +
                  "</clipPath>\n" +
                  "</defs>\n" +
                  "</svg>\n",
              text: "Десерти, солодощі"
            },
            {
              icon: "<svg width=\"15\" height=\"22\" viewBox=\"0 0 15 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<path d=\"M10.0072 2.80866L7.98898 6.30441H7.2338L9.6467 2.12512C9.64672 2.12508 9.64675 2.12504 9.64677 2.12501C9.65265 2.11487 9.65796 2.10476 9.66284 2.09475L9.6629 2.09462C9.71868 1.97987 9.83186 1.90903 9.9591 1.90903H13.8834V2.56686H10.426C10.2532 2.56686 10.0936 2.65904 10.0072 2.80866ZM14.367 3.53406C14.6341 3.53406 14.8506 3.31751 14.8506 3.05046V1.42542C14.8506 1.15838 14.6341 0.941824 14.367 0.941824H9.9591C9.4725 0.941824 9.02065 1.22071 8.80164 1.65444L6.11698 6.30441H2.17923C1.46448 6.30441 0.883108 6.88578 0.883108 7.60053V8.41305C0.883108 8.96748 1.23295 9.441 1.72299 9.62589L2.5094 20.6353C2.56047 21.3507 3.1146 21.897 3.80427 21.897H11.9295C12.6192 21.897 13.1733 21.3507 13.2244 20.6354L14.0108 9.62593C14.5008 9.44103 14.8507 8.96748 14.8507 8.41309V7.60057C14.8507 6.88582 14.2693 6.30445 13.5545 6.30445H9.10576L10.7052 3.53406H14.367ZM12.8385 12.4614L12.5307 16.7712C11.7404 17.1099 11.1413 17.2098 10.6238 17.1877C10.0954 17.1651 9.64672 17.0154 9.1546 16.8506L9.15256 16.8499C8.50756 16.634 7.80985 16.4003 6.87146 16.4409C5.95324 16.4806 4.81124 16.7822 3.26258 17.6054L2.97967 13.6448C4.63962 12.6624 5.79052 12.2825 6.67919 12.1978C7.57328 12.1126 8.20931 12.3249 8.84756 12.5385L8.85012 12.5394C9.37229 12.7141 9.91292 12.8951 10.5656 12.9252C11.1941 12.9542 11.9221 12.8433 12.8385 12.4614ZM11.9295 20.9298H3.80427C3.61642 20.9298 3.48761 20.755 3.47414 20.5664L3.33843 18.6666C4.86587 17.8045 5.93833 17.4803 6.77587 17.4191C7.61987 17.3574 8.23261 17.5619 8.84756 17.7678L8.84942 17.7684C9.33553 17.9311 9.83843 18.0995 10.4325 18.1462C11.0024 18.191 11.6528 18.1238 12.4544 17.8393L12.2596 20.5664C12.2461 20.755 12.1173 20.9298 11.9295 20.9298ZM13.8834 7.60053V8.41305C13.8834 8.59435 13.7358 8.74197 13.5545 8.74197H7.40482C7.13773 8.74197 6.92122 8.95852 6.92122 9.22557C6.92122 9.49261 7.13773 9.70917 7.40482 9.70917H13.0351L12.9169 11.3642C11.9971 11.8142 11.3183 11.9637 10.7449 11.9608C10.1623 11.9579 9.68194 11.7978 9.15464 11.6214L9.15218 11.6205C8.48256 11.3964 7.7581 11.1539 6.76725 11.2174C5.79661 11.2796 4.57728 11.6347 2.9032 12.5728L2.69865 9.70917H3.74857C4.01566 9.70917 4.23217 9.49261 4.23217 9.22557C4.23217 8.95852 4.01566 8.74197 3.74857 8.74197H2.17923C1.99793 8.74197 1.85031 8.59435 1.85031 8.41305V7.60053C1.85031 7.41923 1.99793 7.27161 2.17923 7.27161H13.5545C13.7358 7.27161 13.8834 7.41923 13.8834 7.60053Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.154681\"/>\n" +
                  "<path d=\"M4.59929 13.4302H4.59901C4.33188 13.4302 4.11553 13.6468 4.11553 13.9138C4.11553 14.1809 4.33224 14.3974 4.59929 14.3974C4.86639 14.3974 5.08289 14.1809 5.08289 13.9138C5.08289 13.6468 4.86639 13.4302 4.59929 13.4302Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.154681\"/>\n" +
                  "<path d=\"M7.38738 14.4045H7.38709C7.11997 14.4045 6.90362 14.6211 6.90362 14.8881C6.90362 15.1552 7.12032 15.3717 7.38738 15.3717C7.65448 15.3717 7.87098 15.1551 7.87098 14.8881C7.87098 14.621 7.65448 14.4045 7.38738 14.4045Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.154681\"/>\n" +
                  "<path d=\"M11.5217 14.4453C11.7888 14.4453 12.0053 14.2287 12.0053 13.9617C12.0053 13.6946 11.7888 13.4781 11.5217 13.4781H11.5214C11.2542 13.4781 11.0379 13.6947 11.0379 13.9617C11.0379 14.2288 11.2546 14.4453 11.5217 14.4453Z\" fill=\"#9AB9D8\" stroke=\"#9AB9D8\" stroke-width=\"0.154681\"/>\n" +
                  "</svg>\n",
              text: "Безалкогольні напої"
            },
            {
              icon: "<svg width=\"32\" height=\"22\" viewBox=\"0 0 32 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<g clip-path=\"url(#clip0_4852_6161)\">\n" +
                  "<path d=\"M11.8145 10.995C11.8145 10.995 11.8145 10.995 11.9439 11.125L12.2026 10.4749L3.27646 7.87488C3.27646 7.87488 2.3709 8.00488 2.11217 8.6549C1.59471 9.17491 2.62963 9.95493 2.62963 9.95493L10.7796 12.295H11.4264C11.4264 12.035 11.5558 11.775 11.5558 11.515L11.8145 10.995Z\" stroke=\"#9AB9D8\" stroke-width=\"1.36003\" stroke-miterlimit=\"10\"/>\n" +
                  "<path d=\"M21.5171 11.1253C16.7306 9.95525 12.5909 9.82525 12.3322 10.8653C12.2028 11.1253 12.3322 11.5153 12.7203 11.9053C13.1084 12.1653 13.7552 12.5553 14.5314 13.0753C15.6957 13.5953 17.1187 14.1154 18.8004 14.6354C21.6465 15.4154 24.4925 15.8054 26.5623 16.0654C28.3734 16.1954 29.5377 16.0654 29.7964 15.2854C30.0552 14.1154 26.3036 12.2953 21.5171 11.1253Z\" stroke=\"#9AB9D8\" stroke-width=\"1.36003\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M18.8006 14.5049C16.9894 13.9849 15.6958 13.4649 14.5315 12.9449C13.7553 12.5549 13.2379 12.1648 12.7204 11.9048C12.3323 11.5148 12.0736 11.2548 11.9442 11.1248L11.5561 12.4248L11.4268 12.2948C11.168 14.5049 12.591 16.7149 14.7902 17.495L23.0696 19.965C25.5275 20.745 28.2442 19.315 29.0204 16.7149L29.6672 15.1549C29.6672 15.1549 28.1148 16.0649 26.4331 15.9349C24.7513 15.8049 22.6815 15.5449 20.3529 15.0249C19.9648 14.8949 19.318 14.6349 18.8006 14.5049Z\" stroke=\"#9AB9D8\" stroke-width=\"1.36003\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M11.9432 11.1248C11.8139 10.9948 11.8139 10.9948 11.8139 10.9948L11.5551 11.5148C11.5551 11.7748 11.5551 12.0348 11.4258 12.2948H11.5551L11.9432 11.1248Z\" stroke=\"#9AB9D8\" stroke-width=\"1.36003\" stroke-miterlimit=\"10\"/>\n" +
                  "<path d=\"M20.4815 15.0251C22.8101 15.5451 24.8799 15.9351 26.5617 15.9351C24.4919 15.6751 21.6458 15.2851 18.7998 14.5051C19.3173 14.6351 19.9641 14.8951 20.4815 15.0251Z\" stroke=\"#9AB9D8\" stroke-width=\"1.36003\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M12.7197 11.9049C13.1078 12.2949 13.7546 12.6849 14.5308 13.0749C13.884 12.5549 13.2372 12.1649 12.7197 11.9049Z\" stroke=\"#9AB9D8\" stroke-width=\"1.36003\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M19.9644 5.27476C20.9993 5.27476 21.7755 4.49474 21.7755 3.45472C21.7755 2.41469 20.9993 1.63467 19.9644 1.63467C18.9295 1.63467 18.1533 2.41469 18.1533 3.45472C18.1533 4.49474 19.0589 5.27476 19.9644 5.27476Z\" stroke=\"#9AB9D8\" stroke-width=\"1.36003\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M25.2659 5.23617L22.8613 7.40982L25.0243 9.82625L27.4289 7.6526L25.2659 5.23617Z\" stroke=\"#9AB9D8\" stroke-width=\"1.36003\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "</g>\n" +
                  "<defs>\n" +
                  "<clipPath id=\"clip0_4852_6161\">\n" +
                  "<rect width=\"30.4007\" height=\"20.8005\" fill=\"white\" transform=\"translate(0.947266 0.594849)\"/>\n" +
                  "</clipPath>\n" +
                  "</defs>\n" +
                  "</svg>\n",
              text: "Смажені або тушені на маслі чи маргарині продукти"
            },
          ],
          show: false
        },


        link: {
          name: 'Перейти до алгоритму',
          ref: "/algorithms/allergy"
        },
      },
      {
        img: Image4,
        title: "Як підібрати суміш",
        text: "<b>Основним критерієм</b> є стан дитини (форма тяжкості алергії, симптоми з боку ШКТ, проблеми з набором ваги тощо). <b>Додатковими критеріями</b> можуть бути очікувана швидкість ефекту (амінокислотна суміш діє швидше) й смакові уподобання (амінокислотна суміш приємніша за глибокі гідролізати, які можуть здатися гірчішими)",
        link: '',
      },
      {
        img: Image5,
        title: "При алергії до БКМ будь-якої тяжкості, гастроінтестинальній формі та полівалентній алергії",
        text: "<b>Neocate</b>, на відміну від гідролізатів, виготовляється без використання молока чи його компонентів. Повна елімінація білка забезпечує <b>найшвидший ефект</b> – шкірні симптоми полегшуються впродовж 3 днів, а гастроінтестинальні усуваються впродовж 14 днів. Суміш не містить лактози, отже, легко перетравлюється. Має <b>приємніший смак</b>, ніж глибокі гідролізати",
        drop4: {
          name: "Звідки амінокислоти, якщо не з молочного білка?",
          list: [
            {
              text: "Вільні амінокислоти отримано шляхом хімічного синтезу, реакцій обміну, ферментації, екстрактації та гідролізу речовин немолочного походження",
              icon: "<svg width=\"52\" height=\"48\" viewBox=\"0 0 52 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                  "<path d=\"M35.298 41.4628V43.7535C35.298 45.5463 33.8442 47 32.0514 47C32.0514 47 12.9689 47 4.72271 47C2.66656 47 1 45.3334 1 43.2737V4.63977C1 2.63052 2.63048 1 4.63973 1H31.6582C33.6675 1 35.298 2.63052 35.298 4.63977V10.1986\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M11.8042 1.0036V2.78196C11.8042 3.86775 12.6844 4.74791 13.7702 4.74791H22.5323C23.618 4.74791 24.4982 3.86775 24.4982 2.78196V1.0036\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M50.8705 13.6472L45.8384 18.6793\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M37.9853 10.6061L32.9531 15.6384\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M32.8994 15.7537C35.0782 15.5048 37.1235 16.6375 39.1364 17.5033C43.6924 19.4584 45.8387 18.6792 45.8387 18.6792\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M38.0142 10.6386C40.193 10.3897 42.2383 11.5225 44.2511 12.3882C48.8071 14.3434 50.9535 13.5642 50.9535 13.5642\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M40.4926 24.0289L35.4604 29.061\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M27.6037 20.9879L22.5752 26.0201\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M22.5176 26.1319C24.6964 25.883 26.7417 27.0157 28.7546 27.8814C33.3106 29.8366 35.4569 29.0574 35.4569 29.0574\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M27.6362 21.0168C29.815 20.7679 31.8604 21.9006 33.8732 22.7663C38.4292 24.7215 40.5755 23.9423 40.5755 23.9423\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M30.1106 34.407L25.082 39.4392\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M17.2255 31.366L12.1934 36.3982\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M12.1392 36.5136C14.318 36.2647 16.3633 37.3974 18.3761 38.2631C22.9321 40.2183 25.0785 39.4391 25.0785 39.4391\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M17.2544 31.3949C19.4332 31.146 21.4785 32.2787 23.4914 33.1444C28.0474 35.0996 30.1937 34.3203 30.1937 34.3203\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M33.0437 15.6131C32.5496 15.9341 32.2862 16.5293 32.2429 17.1137C32.1997 17.6981 32.3476 18.2825 32.5315 18.8416C32.7155 19.4007 32.9355 19.949 33.0402 20.5262C33.1448 21.1033 33.1267 21.7274 32.849 22.2468\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M40.1423 17.9903C39.9908 18.2644 39.9042 18.5819 39.8826 18.8957C39.8393 19.4801 39.9872 20.0644 40.1712 20.6235C40.3551 21.1827 40.5752 21.731 40.6798 22.3082C40.7844 22.8854 40.7664 23.5094 40.4886 24.0289\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M22.5716 26.085C22.0774 26.4061 21.8141 27.0012 21.7708 27.5856C21.7275 28.17 21.8754 28.7544 22.0594 29.3135C22.2433 29.8726 22.4634 30.4209 22.568 30.9981C22.6726 31.5753 22.6546 32.1993 22.3768 32.7188\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M29.6706 28.4658C29.5191 28.7399 29.4326 29.0574 29.4109 29.3712C29.3676 29.9556 29.5155 30.54 29.6995 31.0991C29.8835 31.6582 30.1035 32.2066 30.2081 32.7837C30.3127 33.3609 30.2947 33.9849 30.0169 34.5043\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M30.9331 14.2278H17.2832V28.4658\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M5.73975 12.5938H13.077\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M5.73975 16.5618H13.077\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M5.73975 20.5298H13.077\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M5.73975 24.4978H13.077\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M5.73975 28.4658H13.077\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "<path d=\"M35.2983 41.4628V31.4851\" stroke=\"#66CDF0\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                  "</svg>\n"
            }
          ], show: false
        },
        link: {
          name: "Перейти",
          ref: "/production/16"
        },
      },
      {
        img: Image6,
        title: "При легкій і середньотяжкій алергії до БКМ",
        text: "<b>Nutrilon Пепті</b> вирізняється вмістом запатентованої формули пребіотиків GOS/FOS 9:1 у доведено ефективній дозі 0,8 г / 100 мл. Знижений вміст лактози полегшує навантаження на травну систему, але суміш розрахована на дітей без тяжких порушень травлення",
        link: {
          name: "Перейти",
          ref: "/production/1"
        },
      },
      {
        img: Image7,
        title: "При легкій і середньотяжкій алергії до БКМ з гастроінтестинальними проявами",
        text: "<b>Nutrilon Мальабсорбція</b> вирізняється максимально полегшеним навантаженням на травну систему – вміст лактози зменшено до слідової кількості, а 50% жирів складають середньоланцюгові тригліцериди, що засвоюються без ферментів",
        link: {
          name: "Перейти",
          ref: "/production/4"
        },
      },
      {
        img: Image8,
        title: "При легкій і середньотяжкій алергії до БКМ з недобором ваги",
        text: "<b>Infatrini Пептісорб</b> вирізняється підвищеним вмістом білка й інших поживних речовин, високою калорійністю. Травлення полегшено завдяки зниженню вмісту лактози до слідової кількості та середньоланцюговим тригліцеридам, що засвоюються без ферментів і становлять 52% жирів",
        link: {
          name: "Перейти",
          ref: "/production-energy/15"
        },
      },
      {
        img: Image9,
        title: "Відповідність рекомендаціям МОЗ України",
        text: "Склад сумішей алергічного портфелю Nutricia відповідає методичним рекомендаціям з дієтотерапії алергії до БКМ, узгодженим Міністерством охорони здоров’я України й Національною академією медичних наук України",
        link: {
          name: "Ознайомитись",
          ref: "/library-item/guidance/6"
        },
      },
      {
        img: Image10,
        title: "Харчова алергія чи лактазна недостатність",
        text: "Лактазна недостатність є не алергією, а ферментопатією. <b>Спільними симптомами можуть бути лише гастроінтестинальні</b> (здуття, діарея, кольки). Дієтотерапія ґрунтується на виключенні різних компонентів з харчування. Скористайтеся зручним алгоритмом диференційної діагностики та ознайомтеся з науковою статтею",
        link: {
          name: "Перейти до алгоритму",
          ref: "/algorithms/abkm"
        },
        drop5: {
          name: "Симптоми",
          show: false,
          table: {
            row1: {
              text1: "Алергія",
              text2: "ЛН"
            },
            row2: {
              text1: "Шкірні",
              text2: "можливі",
              text3: "– –"
            },
            row3: {
              text1: "Гастроінте- стинальні",
              text2: "можливі",
              text3: "обов’язкові"
            },
            row4: {
              text1: "Респіраторні",
              text2: "можливі",
              text3: "– –"
            }
          }
        },
        drop6: {
          name: "Дієтотерапія",
          show: false,
          table: {
            row1: {
              text1: "Алергія",
              text2: "ЛН"
            },
            row2: {
              text1: "Виключення білка",
              text2: "обов’язково",
              text3: "– –"
            },
            row3: {
              text1: "Виключення лактози",
              text2: "– –",
              text3: "обов'язково"
            },
          }
        },
        link2: {
          name: "Ознайомитись зі статтею",
          ref: "/library-item/article/6"
        },
      },

      {
        img: Image11,
        title: "Бажаєте дізнатись більше?",
        text: "Ознайомтесь з результатами багатоцентрового проспективного дослідження ефективності використання амінокислотних сумішей при тяжких формах атопічного дерматиту, що було проведено під керівництвом С.Л. Няньковського, а також з оглядом останніх іноземних досліджень",
        link: {
          name: "Перейти до дослідження",
          ref: "/library-item/research/10"
        },
        link2: {
          name: "Перейти до огляду",
          ref: "/library-item/article/54"
        },
      },
    ],
  }),
  created() {
    document.body.style.background = '#1E3B89';
  }
}
</script>

<style scoped lang="scss">
@import "../style/vars";

.allergy {
  height: 100%;
  position: relative;

  &-content {
    height: 100%;

    display: flex;
    flex-direction: column;
    align-self: flex-start;

    .header-image {
      margin-bottom: 30px;

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  &-container {
    padding: 0 15px;

    .card {
      background: #fff;
      border-radius: 4px;
      margin-bottom: 36px;

      &-note {
        padding: 0 20px 20px;

        &__text {
          padding-top: 17px;
          font-style: italic;
          font-weight: 600;
          font-size: 15px;
          line-height: 20px;
          color: #9AB9D8;
        }
      }

      &-image {
        border-radius: 5px 5px 0 0;
        overflow: hidden;

        img {
          width: 100%;
          height: auto;
        }
      }

      &-content {
        padding: 9px 19px 20px 20px;

        .number {
          width: 34px;
          height: 34px;

          max-width: 34px;
          max-height: 34px;

          margin-bottom: 8px;

          border-radius: 50%;
          border: 1.17241px solid #9ab9d8;

          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 17px;
          font-weight: bold;
          color: #9ab9d8;
        }

        hr {
          margin-bottom: 14px;
        }

        .title {
          font-weight: 600;
          font-size: 15px;
          line-height: 20px;

          color: #1e3b89;

          margin-bottom: 12px;
        }

        .text {
          font-weight: 300;
          font-size: 14px;
          line-height: 18px;

          color: #1e3b89;

          ::v-deep p {
            margin-bottom: 15px;

            sub {
              line-height: 0;
            }
          }
        }

        .schema {
          margin-top: 20px;

          svg {
            min-width: 100%;
          }
        }
      }

      .drop-list {
        margin-top: 14px;
        margin-bottom: 8px;

        &.drop-list-type2 {
          table {
            width: 100%;

            border: 1px solid rgba(0, 172, 230, 0.6);
            border-top: none;

            thead {
              tr {
                &:nth-child(1) {
                  background: rgba(213, 234, 248, 0.3);

                  td {
                    padding: 11px;
                    text-align: center;
                    color: #1E3B89;
                    font-size: 12px;
                    font-weight: 600;
                  }
                }

                td {
                  &:first-child {

                    border-right: 1px solid rgba(0, 172, 230, 0.6);
                  }
                }
              }
            }

            tbody {
              tr {
                &:first-child {
                  td {
                    border-bottom: 1px solid rgba(0, 172, 230, 0.6);
                  }
                }

                td {
                  &:first-child {

                    width: 45%;
                    border-right: 1px solid rgba(0, 172, 230, 0.6);
                  }

                  &:last-child {
                    width: 55%;
                  }

                  .icon-text {
                    display: flex;
                    align-items: center;
                    padding: 20px 14px;


                    .text {
                      font-size: 11.0933px;
                      line-height: 120%;

                      color: #1E3B89;
                      font-family: $fontR;

                      ::v-deep span {
                        font-size: 8.32px;
                        line-height: 130%;

                        font-family: $fontL;
                      }
                    }

                    .icon {
                      max-width: 19px;
                      min-width: 19px;
                      margin-right: 8px;

                      display: flex;
                      justify-content: center;

                      &.meat {
                        max-width: 22px;
                        min-width: 22px;
                        height: auto;
                        display: block;
                      }

                      svg {
                        display: block;
                      }
                    }

                  }
                }
              }
            }
          }
        }

        &.drop-list-type1 {
          .list-table {
            .list {
              .text {
                font-size: 12px;
              }
            }
          }
        }

        &.drop-list-type5 {
          .list-title {
            font-size: 15px;
          }

          table {

            margin-top: 4px;
            border: 1px solid rgba(0, 172, 230, 0.6);
            border-top: none;

            thead {
              td {
                font-family: $fontSB;
                font-size: 12px;
                line-height: 115%;

                text-align: center;

                color: #1E3B89;
                padding: 8px 6px;

                &:last-child {
                  border-left: 1px solid #E0ECF7;
                }

              }
            }

            tbody {
              tr {
                td {
                  width: 33%;

                  font-size: 12px;
                  line-height: 130%;
                  /* or 16px */

                  text-align: center;

                  /* nutrilon blue */

                  color: #1E3B89;

                  font-family: $fontL;
                  padding: 12px 6px;


                  &:last-child {
                    border-left: 1px solid #E0ECF7;
                  }

                  &:first-child {
                    font-family: $fontR;

                    font-size: 12px;
                    text-align: left;
                    line-height: 130%;

                    color: #1E3B89;

                    background: rgba(203, 223, 242, 0.15);
                  }


                }
              }
            }
          }
        }

        .list-title {
          font-size: 14px;
          line-height: 16px;

          color: white;
          font-family: $fontSB;

          /* blue for buttons */

          background: rgba(0, 172, 230, 0.6);
          border-radius: 5px;
          padding: 12px 12px;

          display: flex;
          align-items: center;
          justify-content: space-between;

          user-select: none;
          cursor: pointer;

          &.active {
            svg {
              transform: rotate(180deg);
            }
          }

          svg {
            min-width: 12px;
            max-width: 12px;

            display: block;
            height: auto;
            transition: all .2s ease;
            margin-left: 10px;
          }
        }

        .list-table {
          border: 1px solid rgba(0, 172, 230, 0.6);
          border-top: none;
          margin-top: 4px;

          .list {
            display: flex;
            align-items: center;
            padding: 19px 20px;

            &:nth-child(2n) {
              background: rgba(213, 234, 248, 0.3);
            }

            .text {
              font-size: 11px;
              line-height: 120%;

              color: #1E3B89;
              font-family: $fontR;
            }

            .icon {
              display: flex;
              align-items: center;
              justify-content: center;
              min-width: 30px;
              max-width: 30px;
              margin-right: 15px;

              svg {
                display: block;
              }
            }
          }
        }

        .list-table-type3 {
          border: 1px solid rgba(0, 172, 230, 0.6);
          border-top: none;
          margin-top: 4px;

          .list {
            display: flex;

            padding: 16px;

            .text {
              font-size: 14px;
              line-height: 130%;
              font-family: $fontL;

              color: #1E3B89;
            }

            .icon {
              margin-right: 4px;

              svg {
                display: block;
              }
            }
          }
        }
      }

      .drop-list:last-child {
        margin-bottom: 0;
      }

      .list {
        .item {
          display: flex;
          flex-direction: row;
          margin-bottom: 14px;

          .icon {
            min-width: 37px;
            margin-right: 16px;
          }

          .item-text {
            font-weight: 300;
            font-size: 14px;
            line-height: 18px;
            color: #1E3B89;
          }
        }
      }

      hr {
        display: block;
        height: 1px;
        border: 0;
        border-top: 1px solid #dae3ed;
        margin-bottom: 7px;
        padding: 0;
      }

      &-link {
        padding: 14px 0;
        border-top: 1px solid #DAE3ED;

        .url {
          display: flex;
          justify-content: center;
          align-items: center;

          font-weight: bold;
          font-size: 15px;
          line-height: 17px;
          letter-spacing: 0.05em;
          color: #00ace6;
        }

        .url::after {
          content: "\203A";

          margin-left: 20px;
          margin-bottom: 3px;

          font-weight: 500;
          font-size: 25px;
          color: #00ace6;
        }
      }
    }

    &-info {
      margin: 0 -15px 0 -15px;
      background: #E1ECF7;
      padding: 20px 20px;

      font-weight: 300;
      font-size: 12px;
      line-height: 15px;

      color: #1E3B89;
    }
  }
}
</style>